export default {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小',
    account: '账号',
    businessUsers: '企业用户',
    userName: '用户名称',
    currentRole: '当前角色',
    personalInformation: '个人信息',
    changePassword: '修改密码',
    tip_notChangePassword: '提示：当前账号不允许修改密码',
    department: '所属部门',
    mobileNumber: '手机号码',
    pleaseEnterPhoneNumber: '请输入手机号码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
}